import { Component } from '@angular/core';
import { LABELS } from "../../../core/constants/label-constants";
import { NgClass, NgStyle } from "@angular/common";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { CommonConstants } from "../../../core/constants/common-constants";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { HelperService } from "../../../core/api-common-service/helper.service";
import { AuthService } from "../auth.service";
import { ApiService } from "../../../core/api-common-service/api.service";
import { Api } from "../../../core/api-common-service/api";
import { HttpClientModule } from "@angular/common/http";
import { Subscription, take, timer } from 'rxjs';
import { encryptData } from '../../../core/encryptData/encrypt-data.service';

@Component({
    selector: 'app-reset-password',
    imports: [
        NgClass,
        ReactiveFormsModule,
        HttpClientModule,
        RouterLink,
        NgStyle
    ],
    providers: [HelperService, AuthService, ApiService, Api],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
    updateForm!: FormGroup;
    otpForm!: FormGroup;
    isSubmitting: boolean = false;
    email: any = ''
    otpLength: any = 6;
    isSendOtp: boolean = false;
    hideResendBtn: boolean = true;
    countDown!: Subscription;
    resendOtp: boolean = false;
    seconds: any;
    displayTimer: boolean = false;
    passwordStrength: string = '';
    constructor(
        private _formBuilder: FormBuilder,
        private _router: Router,
        public _helper: HelperService,
        public _route: ActivatedRoute,
        private _apiService: AuthService
    ) {
        var seconds: any = this._helper.getLocalStorageData(
            CommonConstants.OTP_TIMER
        );
        var otpSent: any = this._helper.getLocalStorageData(
            CommonConstants.OTP_SENT
        );
        if (seconds && otpSent) {
            this.hideResendBtn = true;
            this.startTimer();
        } else if (!seconds && otpSent) {
            this.hideResendBtn = false;
        } else {
            this.hideResendBtn = true;
            this.startTimer();
        }
    }

    /**
         * Summary: For start otp timer
         */
    startTimer() {
        this.isSendOtp = false;
        this.start();
        this.hideResendBtn = true;
    }

    start() {
        this.displayTimer = true;
        this.resendOtp = false;
        this.seconds = 60;
        let timerControl = 1000;

        this.countDown = timer(0, timerControl)
            .pipe(take(this.seconds))
            .subscribe(() => {
                var seconds: any = this._helper.getLocalStorageData(
                    CommonConstants.OTP_TIMER
                );
                if (seconds) {
                    this.seconds = seconds;
                }
                --this.seconds;
                if (this.seconds == 0) {
                    this.countDown.unsubscribe();
                    this.hideResendBtn = false;
                }
                if (this.hideResendBtn) {
                    this._helper.setLocalStorageData(
                        CommonConstants.OTP_TIMER,
                        this.seconds
                    );
                    this._helper.setLocalStorageData(
                        CommonConstants.OTP_SENT,
                        true
                    );
                } else {
                    this._helper.removeLocalStorageData(
                        CommonConstants.OTP_TIMER
                    );
                }
            });
    }
    /**
     * Summary: Get time
     * @param value
     */
    transform(value: number): string {
        const minutes: number = Math.floor(value / 60);
        return (
            ('00' + minutes).slice(-2) +
            ':' +
            ('00' + Math.floor(value - minutes * 60)).slice(-2)
        );
    }

    ngOnInit() {
        this.initializeForm();
        let emailFromSession = this._helper.getSessionData(CommonConstants.FORGOT_EMAIL);
        let emailFromUrl = this._route.snapshot.paramMap.get('id');
        if (emailFromUrl) {
            this.email = this._helper.decryptResponse(emailFromUrl) ? this._helper.decryptResponse(emailFromUrl) : '';
        } else if (emailFromSession) {
            this.email = emailFromSession
        } else {
            this._router.navigate(['login']);
        }
    }

    resendOTP() {
        this.isSendOtp = true;
        let reqData = {
            email: this.email,
        };
        this._helper.removeLocalStorageData(CommonConstants.OTP_TIMER);
        this._apiService.forgotPassword(reqData).subscribe((res: any) => {
            if (res?.meta?.status === 1) {
                this._helper.removeLocalStorageData(CommonConstants.OTP_TIMER);
                this.startTimer();
            } else {
                this.isSendOtp = false;
            }
        });
    }

    initializeForm() {
        this.updateForm = this._formBuilder.group({
            password: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])\S{8,}$/)]],
            confirmPassword: ['', [Validators.required]],
        }, { validator: this.ConfirmedValidator('password', 'confirmPassword') });

        this.updateForm.get('password')?.valueChanges.subscribe((val: string) => {
            this.getPasswordStrength(val);
        });


        this.otpForm = this._formBuilder.group({
            otp0: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp1: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp2: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp3: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp4: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp5: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
        });
    }


    /**
     * Get otp controls
     */
    get otpControls() {
        return Object.keys(this.otpForm.controls);
    }

    /**
     * For check on input and focus on next circle of otp
     * @param event
     * @param index
     */
    onInput(event: any, index: number) {
        const input = event.target;
        input.value = input.value.replace(/[^0-9]/g, '');
        const controlName = `otp${index}`;
        this.otpForm.get(controlName)?.setValue(input.value);

        if (event.key != 'Backspace' && input.value && index < 5) {
            const nextInput = document.querySelector(`input[data-index="${index + 1}"]`) as HTMLInputElement;
            nextInput?.focus();
        }
    }

    /**
     * For check on keydown and focus on next or previous circle
     * @param event
     * @param index
     */
    onKeyDown(event: KeyboardEvent, index: number) {
        const input = event.target as HTMLInputElement;
        if (event.key === 'Backspace' && index > 0) {
            setTimeout(() => {
                if (!input.value) {
                    const prevInput = document.querySelector(`input[data-index="${index - 1}"]`) as HTMLInputElement;
                    prevInput?.focus();
                }
            }, 300);
        } else {
            this.onInput(event, index)
        }
    }

    getPasswordStrength(password: string) {
        if (!password) {
            this.passwordStrength = '';
            return;
        }

        let strength = 0;
        if (password.length >= 8) strength++;
        if (/[a-z]/.test(password)) strength++;
        if (/[A-Z]/.test(password)) strength++;
        if (/[0-9]/.test(password)) strength++;
        if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength++;

        if (strength <= 2) {
            this.passwordStrength = 'Weak';
        } else if (strength === 3) {
            this.passwordStrength = 'Medium';
        } else if (strength === 4) {
            this.passwordStrength = 'Strong';
        } else {
            this.passwordStrength = 'Very Good';
        }
    }

    /**
     * Summery : This method is use for set otp dynamicaly on pest 
     * @param event
     * @returns 
     */
    onPaste(event: ClipboardEvent) {
        const pastedText = event.clipboardData?.getData('text');
        if (!pastedText) return;

        const otpDigits = pastedText.trim().replace(/\D/g, '').slice(0, this.otpLength).split('');

        if (otpDigits.length === this.otpLength) {
            otpDigits.forEach((digit, index) => {
                const input = document.querySelector(`input[data-index="${index}"]`) as HTMLInputElement;
                if (input) {
                    input.value = digit;
                    this.otpForm.get(`otp${index}`)?.setValue(digit);
                }
            });

            event.preventDefault(); // Stop default paste behavior
        }
    }

    /**
     * Summary: this method is use for reset password
     */
    onSubmit() {
        this.updateForm.markAllAsTouched();
        this.otpForm.markAllAsTouched();
        if (this.updateForm.valid) {
            this.isSubmitting = true;
            let otp = this.otpControls.map(key => this.otpForm.get(key)?.value).join('');
            let reqData = {
                password: this.updateForm.value.password,
                email: this.email,
                otp: +otp,
            }
            const encryptedData = {
                data: encryptData(reqData)
            }
            this._apiService.resetPassword(encryptedData).subscribe((res: any) => {
                if (res?.meta?.status === 1) {
                    this.isSubmitting = false;
                    this._router.navigate(['login']);
                    this._helper.toast(res?.meta?.message, 'success');
                } else {
                    this.isSubmitting = false;
                    this._helper.toast(res?.meta?.message, 'error');
                }
            }, (error: any) => { this.isSubmitting = false })
        }
    }

    /**
     * Summary: This method is use for check both password and new password same or not.
     * @param controlName
     * @param matchingControlName
     * @constructor
     */
    ConfirmedValidator(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ confirmedValidator: true });
            } else {
                matchingControl.setErrors(null);
            }
        }
    }

    /**
     * Summary: this method is use for clear data when user go outside from this component
     */
    ngOnDestroy(): void {
        this._helper.removeLocalStorageData(CommonConstants.OTP_TIMER);
        this._helper.removeLocalStorageData(CommonConstants.OTP_SENT);
        sessionStorage.removeItem(CommonConstants.FORGOT_EMAIL);
        sessionStorage.removeItem(CommonConstants.OTP_VALUE);
    }
    protected readonly LABELS = LABELS;
}

